<template>
  <div
    id="preview"
    class="question"
  >
    <h2 class="header">
      {{ $t('gift_giving_report.preview.title') }}
    </h2>
    <div class="content">
      <ExamplePreview
        :delivery-report="deliveryReport"
        :family-words="familyWords"
        :volunteer-words="volunteerWords"
      />
    </div>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import ExamplePreview from '@/components/giftGivingReport/giftGivingReportStep/ExamplePreview';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getGiftGivingReportState',
    mutationType: 'giftGivingReport/updateGiftGivingReportState'
});

export default {
    name: 'GiftGivingPreview',
    components: { ExamplePreview },
    computed: {
        ...mapFields(['deliveryReport', 'familyWords', 'volunteerWords'])
    }
};
</script>

<style scoped></style>
